/**
 * OIMS v2 - Utility functions
 * HTML escaping, loading overlay, log helpers
 */

// Cached DOM refs (set in initUtils)
let loadingOverlay = null;
let loadingMessage = null;

export function initUtils() {
  loadingOverlay = document.getElementById("loadingOverlay");
  loadingMessage = document.getElementById("loadingMessage");
}

export function escapeHtml(str) {
  if (typeof str !== 'string') return str;
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
}

export function showLoading(message = "Loading...") {
  if (loadingOverlay) {
    loadingMessage.textContent = message;
    loadingOverlay.classList.add("show");
  }
}

export function hideLoading() {
  if (loadingOverlay) {
    loadingOverlay.classList.remove("show");
  }
}

function isTextarea(el) {
  return el && el.tagName === "TEXTAREA";
}

export function clearLog(logEl) {
  if (isTextarea(logEl)) {
    logEl.value = "";
  } else {
    logEl.textContent = "";
  }
}

export function appendLog(logEl, line) {
  const text = line.endsWith("\n") ? line : line + "\n";
  if (isTextarea(logEl)) {
    logEl.value += text;
  } else {
    logEl.textContent += text;
  }
  // Only auto-scroll if user is near the bottom (within 100px)
  const nearBottom = logEl.scrollHeight - logEl.scrollTop - logEl.clientHeight < 100;
  if (nearBottom) {
    logEl.scrollTop = logEl.scrollHeight;
  }
}
